<div class="error-message" *ngIf="(control && control.touched) || (control && control.dirty)">
  <span *ngIf="control.errors?.['required']"> {{ name | translate }} {{ 'isRequired.value' | translate }} </span>
  <span *ngIf="control.errors?.['email']"> {{ name | translate }} {{ 'isInvalid.value' | translate }} </span>
  <span *ngIf="control.errors?.['alphabetsOnly']">{{ name | translate }} {{ 'alphabet.value' | translate }}</span>
  <span *ngIf="control.errors?.['invalidPhoneNumber']"
    >{{ name | translate }} {{ 'businessPhoneNumberValidation.value' | translate }}</span
  >
  <span *ngIf="control.errors?.['invalid']">{{ name | translate }} {{ 'isInvalid.value' | translate }}</span>
  <!-- <span *ngIf="control.errors?.['pattern']">{{ name | translate }} {{ 'isInvalid.value' | translate }}</span> -->
  <span *ngIf="control.errors?.['numbersOnly']">{{ 'number.value' | translate }}</span>
  <span *ngIf="control.errors?.['passwordMismatch']"></span>
  <span *ngIf="control.errors?.['invalidPassword']"
    >{{ 'ADMIN.ADMINFORM.PASSWORD.TEXT' | translate }} {{ 'isInvalid.value' | translate }}</span
  >
  <span *ngIf="control.hasError('startTimeNotExceedsEndTime')">{{ 'startTimeAndEndTimeError.value' | translate }}</span>
  <span *ngIf="control.hasError('invalidUntilDate')">{{ 'startDateAndEndDateError.value' | translate }}</span>
  <span *ngIf="control.hasError('phoneLength')">{{ 'phoneLength.value' | translate }}</span>
</div>
